import {default as http} from './HttpService'
import BaseService from "@/services/BaseService";

// Mock data for testing custom reports
const MOCK_CUSTOM_REPORTS = {
  content: [
    {
      uniqueId: "QAP-2023-001",
      type: "QAP",
      createdAt: "2023-08-15T14:30:00",
      lot: "LOT-A123",
      product: "Organic Cotton",
      fileExtension: "xlsx"
    },
    {
      uniqueId: "QAP-2023-002",
      type: "QAP",
      createdAt: "2023-08-16T09:15:00",
      lot: "LOT-B456",
      product: "Premium Cotton",
      fileExtension: "xlsx"
    },
    {
      uniqueId: "DECL-2023-001",
      type: "SUSTAINABILITY_DECLARATION",
      createdAt: "2023-08-14T11:45:00",
      lot: "LOT-C789",
      product: "Sustainable Cotton",
      fileExtension: "docx"
    },
    {
      uniqueId: "DECL-2023-002",
      type: "SUSTAINABILITY_DECLARATION",
      createdAt: "2023-08-17T16:20:00",
      lot: "LOT-D012",
      product: "Biodynamic Cotton",
      fileExtension: "docx"
    },
    {
      uniqueId: "QAP-2023-003",
      type: "QAP",
      createdAt: "2023-08-18T10:30:00",
      lot: "LOT-E345",
      product: "Fair Trade Cotton",
      fileExtension: "xlsx"
    }
  ],
  totalElements: 5,
  size: 10,
  number: 0,
  totalPages: 1
};

// Mock binary data for download
const MOCK_XLSX_CONTENT = new Uint8Array([
  80, 75, 3, 4, 20, 0, 6, 0, 8, 0, 0, 0, 33, 0, 235, 122, 210, 84, 
  201, 0, 0, 0, 88, 1, 0, 0, 13, 0, 0, 0
]);

const MOCK_DOCX_CONTENT = new Uint8Array([
  80, 75, 3, 4, 20, 0, 6, 0, 8, 0, 0, 0, 33, 0, 178, 124, 212, 
  66, 94, 0, 0, 0, 188, 1, 0, 0, 13, 0, 0, 0
]);

class ReportsService extends BaseService {
    constructor() {
        super()
    }

    getDataStock(filters) {
        return http.client.post('/v1/report/stock-closed-projection',filters);
    }
    getProtheusDataFiltered(filters) {
        return http.client.post('/v1/protheus/protheus-filters', filters);
    }
    getDataContracts(filters) {
        return http.client.post('/v1/protheus/get_contract', filters);
    }
    getContract(contract) {
        return http.client.post('v1/protheus/contractData',{contract:contract});
    }
    getVolumesN(company) {
        return http.client.post('/v1/protheus/total-volumen-max-min', {
            company_id: company
        });
    }
    getVolumesB(company) {
        return http.client.post('/v1/protheus/total-benefit-volumen-max-min', {
            company_id: company
        });
    }
    getQuebra(company) {
        return http.client.post('/v1/protheus/quebra-max-min', {
            company_id: company
        });
    }
    getSellersNames(company) {
        return http.client.post('/v1/protheus/contract-seller-name-id', {
            company_id: company
        });
    }
    getContractsNumbers(company) {
        return http.client.post('/v1/protheus/contract-name-id', {
            company_id: company
        });
    }
    getDataSellers(filters) {
        return http.client.post('/v1/protheus/protheus-sellers', filters)
    }
    getGeneralReport(data) {
        return http.client.post('/v1/reports/general-report', data, {
            responseType: 'blob'
        });
    }
    getBiorganicFiltered(filters, source) {
        return http.client.post('/v1/record/records-paginated-to-biorganic-report', filters, {
            cancelToken: source.token
        });
    }
    getTraceabilityFiltered(filters) {
        return http.client.post('/v1/record/records-traceability-paginated', filters);
    }
    getBiorganicReport(filters) {
        return http.client.post('/v1/reports/biorganic-report/excel', filters, {
            responseType: 'blob'
        });
    }
    getTraceabilityV2Report(filters, source) {
        return http.client.post('/v1/record/records-lots-report', filters, {
            cancelToken: source.token
        });
    }
    getExistingTraceabilityReport(filters) {
        return http.client.post('/v1/traceability_saved/get-saved', filters);
    }
    generateReportsByLotAndProduct(data) {
        return http.client.post('/v1/traceability_saved/save-list', data);
    }
    getDateNumberOfPendants() {
        return this.requestWithCancellation('get', '/v1/report/get-date-number-of-pendants', null, 'getDateNumberOfPendants');
    }
    setManualStockUpdate() {
        return http.client.get('/v1/report/manual-stock-update');
    }
    setDateToStartStockReset(data) {
        console.log(data)
        return http.client.post('/v1/report/configuration', data);
    }
    checkCanProcess() {
        return http.client.get('/v1/report/check-can-process');
    }
    getQrList(filters) {
        return http.client.post('/v1/traceability_saved/filter_pageable', filters);
    }
    activeOrDeactive(data) {
        return http.client.put('/v1/traceability_saved/change_active', data);
    }
    setPrintLimit(data) {
        return http.client.put('/v1/traceability_saved/set_print_limit', data);
    }
    getStockDate() {
        return http.client.get('/v1/report/configuration-get-date');
    }
    deleteTraceabilityReport(id) {
        return http.client.delete(`/v1/traceability_saved/${id}`);
    }
    getCustomReportsList(data) {
        // For testing, return mock data
        // if (process.env.NODE_ENV === 'development') {
        //     return Promise.resolve({ data: MOCK_CUSTOM_REPORTS });
        // }
        return http.client.post(`/v1/custom-reports/paginated`, data);
    }
    generateCustomReport(data) {
        return http.client.post(`/v1/custom-reports`, data);
    }
    downloadCustomReport(id) {
        return http.client.get(`/v1/custom-reports/download-file/${id}`, {
            responseType: 'blob'
        });
    }
}

export default new ReportsService()
